/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowUseOfFundsItemDtoSchema = z.object({
  label: z.optional(z.string()),
  pct: z.optional(z.number()),
});
